exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row-edit-mode {\n  background-color: #28a74569 !important; }\n\n.list {\n  border: 1px dotted #ccc;\n  padding: 3px;\n  position: fixed;\n  background-color: white;\n  width: 25rem;\n  overflow: auto;\n  min-height: auto;\n  max-height: 20rem;\n  z-index: 1000 !important; }\n  .list ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0; }\n    .list ul li {\n      color: black;\n      padding: 5px 0;\n      border-bottom: 1px solid #808080ab; }\n      .list ul li:hover {\n        background: #eee;\n        cursor: pointer; }\n\n.code-add {\n  font-size: 13px !important;\n  cursor: pointer;\n  background-color: #e0e0e0;\n  padding: 1px;\n  margin-top: 2px; }\n\n.code-add:hover {\n  color: #1464f6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/autocomplete-payors/autocomplete-payors.component.scss
// module id = 2160
// module chunks = 66